/*
 * PuraKai PUR-1247 (2026-10-13): quick-add popup preorder parity with STOQ's product page.
 * buy-buttons.liquid already renders "Preorder" + a hidden selling_plan input for sold-out preorder
 * variants inside the quick-buy popup. This element adds STOQ's own shipping text (read from
 * window._RestockRocketConfig.sellingPlans, which the STOQ app embed loads on every page) and the
 * same "Preorder" line-item property STOQ adds on the product page. No dates are hard-coded here.
 */
(() => {
  if (window.customElements.get('pk-quick-preorder')) return;

  // undefined = STOQ config not loaded yet; null = STOQ has no enabled offer for this variant
  const findStoqPlan = (variantId) => {
    const cfg = window._RestockRocketConfig;
    if (!cfg || !Array.isArray(cfg.sellingPlans)) return undefined;
    const vid = Number(variantId);
    const market = parseInt(cfg.marketId, 10);
    return (
      cfg.sellingPlans.find(
        (p) =>
          p.enabled &&
          (p.variant_ids || []).includes(vid) &&
          (!p.markets_enabled || (p.shopify_market_ids || []).includes(market))
      ) || null
    );
  };

  class PkQuickPreorder extends HTMLElement {
    connectedCallback() {
      if (this.render()) return;
      const retry = () => this.render();
      document.addEventListener('stoq:loaded', retry, { once: true });
      window.addEventListener('load', retry, { once: true });
    }

    render() {
      const form = this.closest('form');
      if (!form) return true;
      const plan = findStoqPlan(this.getAttribute('variant-id'));
      if (plan === undefined) return false; // keep the Liquid state (plan attached, no ship text)

      const planInput = form.querySelector('[data-pk-preorder-plan]');
      const propInput = form.querySelector('[data-pk-preorder-prop]');
      const button = form.querySelector('buy-buttons button[type="submit"]');

      if (plan === null) {
        // STOQ is not running a preorder for this variant: plain add to cart, like the product page
        planInput?.remove();
        propInput?.remove();
        if (button && button.children.length === 0) button.textContent = this.getAttribute('add-label');
        this.hidden = true;
        return true;
      }

      if (planInput && plan.shopify_selling_plan_id) planInput.value = String(plan.shopify_selling_plan_id);
      if (button && button.children.length === 0 && plan.preorder_button_text) button.textContent = plan.preorder_button_text;

      const text = (plan.shipping_text || plan.preorder_shipping_text || '').trim();
      if (propInput && text && plan.shipping_line_item_property_enabled) {
        propInput.value = text;
        propInput.disabled = false;
      }

      if (text && plan.preorder_button_description_show_shipping !== false) {
        const box = document.createElement('div');
        box.className = 'restock-rocket-preorder-description pk-quick-preorder__box';
        box.style.backgroundColor = plan.preorder_button_description_background_color || '#1F2937';
        box.style.borderRadius = (plan.preorder_button_description_border_radius ?? 10) + 'px';
        const item = document.createElement('div');
        item.className = 'preorder-detail-item';
        item.style.color = plan.preorder_button_description_text_color || '#FFFFFF';
        const span = document.createElement('span');
        span.className = 'preorder-detail-text';
        span.textContent = text;
        item.appendChild(span);
        box.appendChild(item);
        this.replaceChildren(box);
        this.hidden = false;
      }
      return true;
    }
  }

  window.customElements.define('pk-quick-preorder', PkQuickPreorder);
})();
